import { path } from 'ramda'

const ApiErrorMessages = {
  CLIENT_ERROR: 'Sorry something went wrong, please try again.',
  SERVER_ERROR: 'Sorry something went wrong, please try again later.',
  TIMEOUT_ERROR: 'Request timed out.',
  CONNECTION_ERROR: 'Unable to reach our servers.',
  NETWORK_ERROR: 'Unable to reach our servers.',
  CANCEL_ERROR: ''
}

export const BuildErrorMsg = (resp) => {
  const errors = path(['errors'], resp.data)
  if (errors) {
    if (Array.isArray(errors)) { return errors }
    if (path(['fullMessages'], errors)) { return errors.fullMessages }
  }
  return ApiErrorMessages[resp.problem]
}


// WEBPACK FOOTER //
// ./src/Sagas/ApiHelpers.js